(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rheidon-about-values"] && !Shopify.designMode) return;
  try {
    
  class RheidonAboutValues extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedToValues) return;
      this.isConnectedToValues = true;

      this.track = this.querySelector('[data-rheidon-about-values-track]');
      this.sticky = this.querySelector('[data-rheidon-about-values-sticky]');
      this.items = Array.from(this.querySelectorAll('[data-rheidon-about-values-item]'));
      this.buttons = Array.from(this.querySelectorAll('[data-rheidon-about-values-button]'));
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.frame = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.buttons.forEach((button) => button.addEventListener('click', this.handleClick));
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.setActive(0, true);
      this.handleScroll();
    }

    disconnectedCallback() {
      this.buttons?.forEach((button) => button.removeEventListener('click', this.handleClick));
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.isConnectedToValues = false;
    }

    handleClick(event) {
      const item = event.currentTarget.closest('[data-rheidon-about-values-item]');
      const index = Number(item?.dataset.itemIndex);
      if (!Number.isFinite(index)) return;

      if (this.desktopQuery.matches) {
        this.scrollToItem(index);
      } else {
        this.setActive(index);
      }
    }

    handleBlockSelect(event) {
      const item = event.target.closest?.('[data-rheidon-about-values-item]');
      if (!item || !this.contains(item)) return;
      const index = Number(item.dataset.itemIndex);
      if (!Number.isFinite(index)) return;

      if (this.desktopQuery.matches) {
        this.scrollToItem(index);
      } else {
        this.setActive(index);
      }
    }

    handleResize() {
      this.handleScroll();
    }

    handleScroll() {
      if (!this.desktopQuery.matches || !this.track || !this.sticky || this.items.length < 2) return;
      if (this.frame) return;

      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        const rect = this.track.getBoundingClientRect();
        const scrollable = Math.max(this.track.offsetHeight - this.sticky.offsetHeight, 1);
        const travelled = Math.min(Math.max(-rect.top, 0), scrollable);
        const index = Math.round((travelled / scrollable) * (this.items.length - 1));
        this.setActive(index);
      });
    }

    scrollToItem(index) {
      if (!this.track || !this.sticky) return;
      const scrollable = Math.max(this.track.offsetHeight - this.sticky.offsetHeight, 0);
      const step = this.items.length > 1 ? scrollable / (this.items.length - 1) : 0;
      const trackTop = window.scrollY + this.track.getBoundingClientRect().top;

      window.scrollTo({
        top: trackTop + step * index,
        behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
      });
    }

    setActive(index, force = false) {
      const nextIndex = Math.min(Math.max(index, 0), this.items.length - 1);
      if (!force && nextIndex === this.activeIndex) return;
      this.activeIndex = nextIndex;

      const activeHeight = 47.6578;
      const inactiveHeight = 22.0978;
      const gap = 4.0733;
      let top = 0;

      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === nextIndex;
        const height = isActive ? activeHeight : inactiveHeight;
        const button = item.querySelector('[data-rheidon-about-values-button]');
        const copy = item.querySelector('[data-rheidon-about-values-copy]');

        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-before-active', itemIndex < nextIndex);
        item.classList.toggle('is-after-active', itemIndex > nextIndex);
        item.style.setProperty('--rheidon-about-values-item-top', `${top}%`);
        item.style.setProperty('--rheidon-about-values-item-height', `${height}%`);
        button?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        copy?.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (copy) copy.inert = !isActive;

        top += height;
        if (itemIndex < this.items.length - 1) top += gap;
      });
    }
  }

  if (!customElements.get('rheidon-about-values')) {
    customElements.define('rheidon-about-values', RheidonAboutValues);
  }

  } catch(e) { console.error(e); }
})();
})();
